/* eslint-disable react/jsx-no-bind */
import React from "react";
import PropTypes from "prop-types";
import { change, Field, reduxForm } from "redux-form";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputLabel from "@material-ui/core/InputLabel";

import { pad } from "../../../../../helpers/functions/utils";

import GoogleAutocompleteField from "../../../../../components/commons/fields/GoogleAutocompleteField";
import MuiSelectField from "../../../../../components/commons/fields/MuiSelectField";
import MuiTextField from "../../../../../components/commons/fields/MuiTextField";

import translation from "../../../../../translation/translation";
import store from "../../../../../redux/store";
import validate from "./validate";

function renderOptions(name, minHour = 7, maxHour = 21) {
  const options = [
    <option key={"empty"} value="">
      -
    </option>,
  ];

  for (let i = minHour; i < maxHour + 1; i++) {
    options.push(
      <option key={i + (name ? name : Math.random())} value={pad(i)}>
        {pad(i)}
      </option>
    );
  }

  return options;
}

const labelStyle = {
  marginBottom: "10px",
  display: "block",
};

function CreateUnavailabilityForm(props) {
  function handleChangePlace(place) {
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    if (lat && lng) {
      store.dispatch(
        change("createUnavailabilityForm_schedule", "latitude", lat)
      );
      store.dispatch(
        change("createUnavailabilityForm_schedule", "longitude", lng)
      );
    } else {
      store.dispatch(
        change("createUnavailabilityForm_schedule", "location", "")
      );
    }
  }

  function handleFieldBlur(e) {
    e.stopPropagation();
  }

  const {
    handleSubmit,
    createAction: { loading },
    maxHour,
    minHour,
  } = props;

  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      <div className="col-xs-12">
        <InputLabel style={labelStyle}>
          {translation().schedule.unavailability.forms.labels.start}
        </InputLabel>
      </div>
      <div className="clearfix" />
      <div className="col-xs-6">
        <div className="field-wrapper">
          <Field
            onBlurProps={handleFieldBlur}
            name="hour_start"
            fullWidth
            component={MuiSelectField}
          >
            {renderOptions("_hour_start", minHour, maxHour)}
          </Field>
        </div>
      </div>
      <div className="col-xs-6">
        <div className="field-wrapper">
          <Field
            onBlurProps={handleFieldBlur}
            name="min_start"
            fullWidth
            component={MuiSelectField}
          >
            <option value="">-</option>
            <option value={"00"}>00</option>
            <option value={"15"}>15</option>
            <option value={"30"}>30</option>
            <option value={"45"}>45</option>
          </Field>
        </div>
      </div>
      <div className="clearfix" />
      <div className="col-sm-12">
        <InputLabel style={labelStyle}>
          {translation().schedule.unavailability.forms.labels.end}
        </InputLabel>
      </div>
      <div className="clearfix" />
      <div className="col-xs-6">
        <div className="field-wrapper">
          <Field
            onBlurProps={handleFieldBlur}
            name="hour_end"
            fullWidth
            component={MuiSelectField}
          >
            {renderOptions("_hour_end", minHour, maxHour)}
          </Field>
        </div>
      </div>
      <div className="col-xs-6">
        <div className="field-wrapper">
          <Field
            component={MuiSelectField}
            fullWidth
            onBlurProps={handleFieldBlur}
            name="min_end"
          >
            <option value="">-</option>
            <option value={"00"}>00</option>
            <option value={"15"}>15</option>
            <option value={"30"}>30</option>
            <option value={"45"}>45</option>
          </Field>
        </div>
      </div>
      <div className="clearfix" />
      <div className="col-xs-12">
        <div className="field-wrapper">
          <Field
            className="GoogleAutocompleteField"
            changeInputValueOnSelect
            component={GoogleAutocompleteField}
            id="adresse"
            label={translation().schedule.unavailability.forms.labels.place}
            name="location"
            onSelect={handleChangePlace}
            required
            type="text"
          />
          <div style={{ marginTop: 12 }}>
            <Field
              component={MuiTextField}
              fullWidth
              id="title"
              name="title"
              label={translation().schedule.unavailability.forms.labels.title}
              type="text"
            />
          </div>
          <Field
            component="input"
            id="latitude"
            name="latitude"
            type="hidden"
          />
          <Field
            component="input"
            id="longitude"
            name="longitude"
            type="hidden"
          />
        </div>
      </div>
      <div className="clearfix" />
      <div className="submit-wrapper">
        <Button
          color="primary"
          className="btn-unavailability"
          disabled={loading}
          style={{ minWidth: 150 }}
          type="submit"
          onBlur={handleFieldBlur}
          variant="contained"
        >
          {loading ? (
            <CircularProgress size={20} color="secondary" />
          ) : (
            <span>
              {translation().schedule.unavailability.create.buttons.submit}
            </span>
          )}
        </Button>
      </div>
    </form>
  );
}

CreateUnavailabilityForm.propTypes = {
  createAction: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.any,
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  maxHour: PropTypes.number.isRequired,
  minHour: PropTypes.number.isRequired,
};

export default reduxForm({
  form: "createUnavailabilityForm_schedule",
  enableReinitialize: true,
  validate,
})(CreateUnavailabilityForm);
